<template>

  <div class="allFooter">

      <nav class="tableFooter">

        <div class="columnOne">
          <div class="titleFooter"><h2>CHAPSTORY</h2></div>
          <a :href="'/about'" class="textFooter">Sobre</a>
          <a :href="'/beginning'" class="textFooter">Como Surgiu</a>
          <!-- <div class="textFooter">Como Surgiu</div> -->
          <a :href="'/terms'" class="textFooter">Termos de Uso</a>
          <a :href="'/privacy'" class="textFooter">Política de Privacidade</a>
        </div>

        <div class="columnTwo">
          <div class="titleFooter"><h2>DÚVIDAS</h2></div>
          <a href="https://youtu.be/LSl7t-FqxN0" class="textFooter">Como utilizar o site</a>
          <a class="textFooter"><i>Perguntas Frequentes</i></a>
          <a href="/tell_us" class="textFooter">Fale Conosco</a>
        </div>

        <div class="columnThree">
          <div class="titleFooter"><h2>ACOMPANHE-NOS</h2></div>
          <a href="https://www.facebook.com/chapstory2018/" target="_blank" class="textFooter">Facebook</a>
          <a href="https://twitter.com/chapstory" target="_blank" class="textFooter">Twitter</a>
          <a href="https://www.instagram.com/chapstory_com/" target="_blank" class="textFooter">Instagram</a>
          <!-- <a class="textFooter">Youtube</a> -->
        </div>

      </nav>

        <div class="Copyright">
          <small class="titleFooter">© 2018-{{ new Date().getFullYear() }} CHAPSTORY</small>
        </div>

  </div>

</template>

<script>
//
  export default {
  }
</script>

<style lang="scss" scoped>

  .allFooter{
    max-width: 1366px;
    margin: auto;
  }

  a:hover{
    text-decoration:none;
  }

  .columnOne{
    display: grid;
    position: relative;
    width: auto;
    float: left;
    margin: 1em;
  }

  .columnTwo{
    display: grid;
    position: relative;
    width: auto;
    float: left;
    margin: 1em;
  }

  .columnThree{
    display: grid;
    position: relative;
    width: auto;
    float: left;
    margin: 1em;
  }

  .tableFooter{
    display: flex;
    justify-content: space-evenly;
  }

  .titleFooter{
    color: #fff;
    font-weight: 300;
  }

  .textFooter {
    color: #fff!important;
  }

  .textFooter:hover {
    cursor: pointer;
    color: #11999e!important;
  }

  .linksFooter{
    color: #fff;
    cursor: pointer;
  }

  .linksFooter:hover{
    color: #11999e;
  }

  .Copyright{
    text-align:center;
    margin: 1em;
  }

  @media (max-width: 425px) {
    .tableFooter{
      display: grid;
      text-align: center
    }

    .Copyright{
      text-align:center;
    }
  }

</style>
